import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { Checkbox, FormControlLabel, Stack } from '@mui/material';
import { Position } from '@xyflow/react';
import { useGetAiModelsByProviderIdQuery, useGetAiProvidersQuery } from 'services/aiProviderApi';
import { BaseNode } from 'pages/assistants/builder/components/nodes/baseNode';
import { CompactNodeField } from 'pages/assistants/builder/components/nodes/compactNodeField';
import IndeterminateLoading from 'components/Loading/IndeterminateLoading';

export function ModelNode({ id, data, onEditNode, onDeleteNode }) {
  const { formatMessage: msg } = useIntl();

  const { data: providers = [], isLoading: providersLoading } = useGetAiProvidersQuery();
  const selectedProvider = providers.find((p) => p.code === data?.providerCode);
  const selectedProviderId = selectedProvider?.id;

  const { data: models = [], isLoading: modelsLoading } = useGetAiModelsByProviderIdQuery(
    selectedProviderId,
    { skip: !selectedProviderId }
  );
  const selectedModel = models.find((m) => m.code === data?.modelCode);

  return (
    <BaseNode
      id={id}
      icon="smart_toy_icon"
      nodeData={{ ...data, label: msg({ id: 'field.model.label' }) }}
      color="error"
      handleConf={[
        { type: 'target', position: Position.Top, style: { background: 'orange' } },
        { type: 'target', position: Position.Left },
        { type: 'source', position: Position.Right },
        { type: 'target', position: Position.Bottom, style: { background: '#8c8b95' } }
      ]}
      onEditNode={onEditNode}
      onDeleteNode={onDeleteNode}
    >
      <Stack spacing={1} sx={{ p: 1, width: '280px' }}>
        {providersLoading || modelsLoading ? (
          <IndeterminateLoading />
        ) : (
          <>
            <CompactNodeField
              label={msg({ id: 'field.provider.label' })}
              value={selectedProvider ? selectedProvider.label : 'Aucun'}
            />
            <CompactNodeField
              label={msg({ id: 'field.model.label' })}
              value={selectedModel ? selectedModel.label : 'Aucun'}
            />
            <CompactNodeField
              label={msg({ id: 'field.outputvar.label' })}
              value={data?.outputVar || 'output'}
            />

            <FormControlLabel
              control={<Checkbox checked={!!data?.isStreamed} disabled />}
              label={msg({ id: 'field.streamed.label' })}
            />

            <FormControlLabel
              control={<Checkbox checked={!!data?.isStructuredOutput} disabled />}
              label={msg({ id: 'field.structuredOutput.label' })}
            />
          </>
        )}
      </Stack>
    </BaseNode>
  );
}

ModelNode.propTypes = {
  id: PropTypes.string.isRequired,
  data: PropTypes.shape({
    id: PropTypes.number,
    providerCode: PropTypes.string,
    modelCode: PropTypes.string,
    isStructuredOutput: PropTypes.bool,
    schema: PropTypes.object,
    outputVar: PropTypes.string,
    isStreamed: PropTypes.bool
  }),
  onEditNode: PropTypes.func.isRequired,
  onDeleteNode: PropTypes.func.isRequired
};
